import React from 'react';
import classnames from 'classnames';
import { Icon } from 'tea-component';
import { getUploadStatusUIData } from '@gp/pages/Pipeline/ProjectDetails/Milestone/utils';

import type { IBaseProps } from '@home/types/common';
import type { IUploadStatus } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

interface IFileStateProps extends IBaseProps {
  // state: 1 | 2 | 3 | 4; // 1：成功，2：失败，3：等待，4：进行中
  state: IUploadStatus;
  progress: number;
}

const FileState: React.FC<IFileStateProps> = (props) => {
  const { className, style, state = 1, progress = 1 } = props;

  const { teaIcon: teaStatusIcon, icon: statusIcon, text: statusText } = getUploadStatusUIData(state) || {};

  const formattedStatusText = statusText?.replace('[progress]', `${Math?.round(progress * 100)}%`) || '';

  const renderStatusIcon = () => {
    if (state === 3) return <img src={statusIcon} alt="" />;
    {
      /* icon三种状态  success  error loading */
    }
    return <Icon type={teaStatusIcon} />;
  };

  return (
    <div style={style} className={classnames('dbg-gr-status', className)}>
      <div className="dbg-gr-status-text">
        {renderStatusIcon()}
        <span>{formattedStatusText}</span>
      </div>
    </div>
  );
};

export default FileState;
